<script setup>

import { defineProps, defineEmits, computed} from "vue";
import { DateTime } from "luxon";
import BarraNavegacao from "./BarraNavegacao.vue";
import PedidoDeCompraConteudo from "./PedidoDeCompraConteudo.vue";
import UtilNumber from "../../../utils/UtilNumber";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "revisandoPedido",
    "pedidoDeCompra",
    "fornecedores",
    "parcelasCondicoesDePagamento",
    "itensUnidades",
    "cotacoesDePedidoDeCompra",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:revisandoPedido",
    "update:pedidoDeCompra",
    "update:cacheFornecedores",
    "update:cotacaoDePedidoDeCompraItem",
    "update:controlesDesativados",
]);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:controlesDesativados',update);

};

//==================================================================//
//=================== Altera Revisando Pedido ======================//
//==================================================================//

const alteraRevisandoPedido = (update) =>{

    emits('update:revisandoPedido',update);

};

//==================================================================//
//================== Altera Cache Fornecedores =====================//
//==================================================================//

const alteraCacheFornecedores = (update) =>{

    emits('update:cacheFornecedores',update);

};

//==================================================================//
//============ Altera Cotacao Pedido de Compra Item ================//
//==================================================================//

const alteraCotacaoDePedidoDeCompraItem = (update) =>{

    emits('update:cotacaoDePedidoDeCompraItem',update);

};

//==================================================================//
//==================== Altera Cache Fornecedor =====================//
//==================================================================//

const alteraCacheFornecedor = (update) =>{

    update.id = props?.pedidoDeCompra?.fornecedor?.id;

    let fornecedores = props?.fornecedores?.map((fornecedor)=>{

        if(fornecedor.id == update.id){

            return{
                ...fornecedor,
                ...update,
                status:"Invalido",
            }

        }

        return fornecedor;

    });

    alteraCacheFornecedores(fornecedores);

};

//==================================================================//
//=================== Altera Pedido de Compra ======================//
//==================================================================//

const alteraPedidoDeCompra = (update)=>{

    emits('update:pedidoDeCompra',{
        ...props.pedidoDeCompra,
        ...update
    });

};

//==================================================================//
//=============== Altera Pedido de Compra Status ===================//
//==================================================================//

const alteraPedidoDeCompraStatus = (status="")=>{

    let pedidoDeCompra = {...props.pedidoDeCompra};

    // Altera Fornecedor Status
    pedidoDeCompra.fornecedor.status = status;

    // Altera Itens Status
    pedidoDeCompra.itens = pedidoDeCompra.itens.map((item)=>{

        return{
            ...item,
            abrir: false,
            remover: false,
            status: status,
        }

    });

    // Altera Parcelas Status
    pedidoDeCompra.parcelas = pedidoDeCompra.parcelas.map((parcela)=>{

        if(parcela.status == "Leitura"){
            return parcela;
        }

        return{
            ...parcela,
            remover: false,
            status: status,
        }

    });

    // Altera Observações Gerais Status
    pedidoDeCompra.observacoesGerais.status = status;

    alteraPedidoDeCompra({
        ...pedidoDeCompra
    })

}

//==================================================================//
//====================== Altera Fornecedor =========================//
//==================================================================//

const alteraFornecedor = (update)=>{

    alteraPedidoDeCompra({
        fornecedor: update,
    });

};

//==================================================================//
//======================= Troca Fornecedor =========================//
//==================================================================//

const trocaFornecedor = (update)=>{

    // Ao Trocar o Fornecedor, remova o Vendedor do Fornecedor
    
    // Invalide os Itens e Remova deles o Material Fornecido.
    let itens = props?.pedidoDeCompra?.itens?.map((item)=>{

        return{
            ...item,
            status: "Invalido",
            osItemFornecedorMaterialFornecido: "",
        }

    });

    // Valide se a Ultima Observação do novo Fornecedor é Invalida ou Valida. 
    let observacoesGerais = {
        valor: update?.ultimaObservacao,
        status: update?.ultimaObservacao ? "Valido" : "Invalido"
    }

    alteraPedidoDeCompra({
        fornecedor: update,
        fornecedorVendedor: null,
        itens: itens,
        observacoesGerais: observacoesGerais
    });

};

//==================================================================//
//================== Altera Fornecedor Vendedor ====================//
//==================================================================//

const alteraFornecedorVendedor = (update)=>{

    alteraPedidoDeCompra({
        fornecedor: {
            ...props.pedidoDeCompra.fornecedor,
            status: "Valido"
        },
        fornecedorVendedor: update
    });

};

//==================================================================//
//============== Altera Fornecedor Ultima Observacao ===============//
//==================================================================//

const alteraFornecedorUltimaObservacao = (update)=>{

    alteraPedidoDeCompra({
        fornecedor: {
            ...props.pedidoDeCompra.fornecedor,
            ultimaObservacao: update
        },
    });

    alteraCacheFornecedor({
        ultimaObservacao: update
    });

};

//==================================================================//
//======================== Altera Itens ============================//
//==================================================================//

const alteraItens = (update={})=>{

    let itens = props?.pedidoDeCompra?.itens?.map((item)=>{

        if(item?.status == "Leitura"){
            return item;
        }

        return{
            ...item,
            ...update
        }

    });

    alteraPedidoDeCompra({
        itens:itens
    });

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update)=>{

    let itens = props?.pedidoDeCompra?.itens?.map((item)=>{

        if(item.id == update.id){

            return{
                ...item,
                ...update
            }

        }

        return item;

    });

    alteraPedidoDeCompra({
        itens:itens
    });

};

//==================================================================//
//========================= Adiciona Item ==========================//
//==================================================================//

const adicionaItem = (update)=>{

    let itens = props.pedidoDeCompra.itens;
    let item = update;

    itens.push(item);

    alteraPedidoDeCompra({
        itens:itens
    });

};

//==================================================================//
//========================= Adiciona Item ==========================//
//==================================================================//

const removeItem = (update)=>{

    let item = update;
    let itens = props?.pedidoDeCompra?.itens;

    let itemDeletarIndex = itens.findIndex(({id}) => id == item.id);
    itens.splice(itemDeletarIndex, 1);

    alteraPedidoDeCompra({
        itens: itens
    });

    alteraCotacaoDePedidoDeCompraItem({
        cotacaoItem: item,
        cotacaoItemPatch:{
            adicionado: false
        }
    });

};

//==================================================================//
//===================== Adiciona Parcela ===========================//
//==================================================================//

const adicionaParcela = ()=>{

        let dataEntrega = DateTime.now().startOf("day");

        let dataVencimento = DateTime.fromISO(dataEntrega).set({weekday: 3}).startOf("day");

        if(dataEntrega > dataVencimento){

            // Pega a próxima Quarta Feira.
            dataVencimento = dataEntrega.plus({days: (7 - dataEntrega.weekday + 3) % 7});

        }

        dataEntrega = dataEntrega.toFormat("dd/MM/yyyy");
        dataVencimento = dataVencimento.toFormat("dd/MM/yyyy");

        let parcelas = props.pedidoDeCompra.parcelas;

        parcelas.push({
            id: new Date().getTime(),
            status: "Invalido",
            leitura: false,
            adicionada: true,
            remover: false,
            tipo: "Faturamento",
            descricao: "Nova Parcela",
            diasVencimento: 0,
            dataEntrega: dataEntrega,
            dataVencimento: dataVencimento,
            percentual: 0,
            valor: 0,
            referenciaEvento: "C/Pedido de compra",
        });

        alteraPedidoDeCompra({
            parcelas: parcelas
        })

};

//==================================================================//
//====================== Altera Parcela ============================//
//==================================================================//

const alteraParcela = (update)=>{

    let parcelas = props?.pedidoDeCompra?.parcelas?.map((parcela)=>{

        if(parcela.id == update.id){

            return{
                ...parcela,
                ...update
            }

        }

        return parcela;

    });

    alteraPedidoDeCompra({
        parcelas:parcelas
    });

};

//==================================================================//
//====================== Altera Parcela ============================//
//==================================================================//

const removeParcelaRascunho = (update)=>{

    let parcelas = props?.pedidoDeCompra?.parcelas;

    let parcelaDeletarIndex = parcelas.findIndex(({id}) => id == update.id);
    parcelas.splice(parcelaDeletarIndex, 1);

    alteraPedidoDeCompra({
        parcelas: parcelas
    })

};

//==================================================================//
//================ Altera Observações Gerais =======================//
//==================================================================//

const alteraObservacoesGerais = (update)=>{

    alteraPedidoDeCompra({
        observacoesGerais:update
    });

};

//==================================================================//
//======== Soma Itens Preco Total Com Impostos Com IPI =============//
//==================================================================//

const somaItensPrecoTotalComImpostosComIPI = computed(() => {

    let soma = props?.pedidoDeCompra?.itens?.reduce((acc,{osItemPrecoTotalComImpostosComIPI})=>{

        acc += osItemPrecoTotalComImpostosComIPI;
        return acc;

    },0)||0;

    return Number(soma.toFixed(2));

});

//==================================================================//
//=================== Soma Parcelas Leitura Valor ==================//
//==================================================================//

const somaParcelasLeituraValor = computed(() => {

    return props?.pedidoDeCompra?.parcelas?.reduce((acc,parcela)=>{

        if(parcela.status == "Leitura"){
            acc += parcela.valor;
        }

        return acc;

    },0)||0;

});

//==================================================================//
//======================== Soma Valor Total ========================//
//==================================================================//

const somaValorTotal = computed(() => {

    return UtilNumber.clamp(somaItensPrecoTotalComImpostosComIPI.value,somaParcelasLeituraValor.value,999999999);

});

//==================================================================//
//===================== Soma Custo Adicional =======================//
//==================================================================//

const somaCustoAdicional = computed(() => {

    let custoAdicional = somaItensPrecoTotalComImpostosComIPI.value - somaParcelasLeituraValor.value;

    return UtilNumber.clamp(custoAdicional,0,999999999)

});

//==================================================================//
//================== Soma Valor Sobressalente ======================//
//==================================================================//

const somaValorSobressalente = computed(() => {

    let valorSobressalente = somaParcelasLeituraValor.value - somaItensPrecoTotalComImpostosComIPI.value;

    return UtilNumber.clamp(valorSobressalente,0,999999999)

});

//==================================================================//
//=================== Soma Parcelas Novas Valor ====================//
//==================================================================//

const somaParcelasNovasValor = computed(() => {

    return props?.pedidoDeCompra?.parcelas?.reduce((acc,parcela)=>{

        if(parcela.status != "Leitura"){
            acc += parcela.valor;
        }

        return acc;

    },0)||0;

});

//==================================================================//
//======================= Soma Valor Restante ======================//
//==================================================================//

const somaValorRestante = computed(() => {

    return somaCustoAdicional.value - somaParcelasNovasValor.value;

});

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.revisandoPedido"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :revisandoPedido="props.revisandoPedido"
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :pedidoDeCompra="props.pedidoDeCompra"
                    :somaValorRestante="somaValorRestante"
                    :controlesDesativados="props.controlesDesativados"
                    @update:revisandoPedido="alteraRevisandoPedido"
                    @update:pedidoDeCompraStatus="alteraPedidoDeCompraStatus"
                    @update:controlesDesativados="alteraControlesDesativados"
                ></BarraNavegacao>
            
                <PedidoDeCompraConteudo
                    :revisandoPedido="props.revisandoPedido"
                    :pedidoDeCompra="props.pedidoDeCompra"
                    :fornecedores="props.fornecedores"
                    :itensUnidades="props.itensUnidades"
                    :cotacoesDePedidoDeCompra="props.cotacoesDePedidoDeCompra"
                    :parcelasCondicoesDePagamento="props.parcelasCondicoesDePagamento"
                    :somaValorTotal="somaValorTotal"
                    :somaCustoAdicional="somaCustoAdicional"
                    :somaValorSobressalente="somaValorSobressalente"
                    :somaParcelasNovasValor="somaParcelasNovasValor"
                    :somaValorRestante="somaValorRestante"
                    :controlesDesativados="props.controlesDesativados"
                    @update:alteraFornecedor="alteraFornecedor"
                    @update:trocaFornecedor="trocaFornecedor"
                    @update:fornecedorVendedor="alteraFornecedorVendedor"
                    @update:fornecedorUltimaObservacao="alteraFornecedorUltimaObservacao"
                    @update:itens="alteraItens"
                    @update:item="alteraItem"
                    @update:adicionaItem="adicionaItem"
                    @update:removeItem="removeItem"
                    @update:cotacaoDePedidoDeCompraItem="alteraCotacaoDePedidoDeCompraItem"
                    @update:adicionaParcela="adicionaParcela"
                    @update:alteraParcela="alteraParcela"
                    @update:removeParcelaRascunho="removeParcelaRascunho"
                    @update:observacoesGerais="alteraObservacoesGerais"
                    @update:controlesDesativados="alteraControlesDesativados"
                ></PedidoDeCompraConteudo>

            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

